// src/i18n/locales/ar.js

export default {
  countries: {
    'AF': 'أفغانستان',
    'AL': 'ألبانيا',
    'DZ': 'الجزائر',
    'AD': 'أندورا',
    'AO': 'أنغولا',
    'AG': 'أنتيغوا وباربودا',
    'AR': 'الأرجنتين',
    'AM': 'أرمينيا',
    'AU': 'أستراليا',
    'AT': 'النمسا',
    'AZ': 'أذربيجان',
    'BS': 'البهاما',
    'BH': 'البحرين',
    'BD': 'بنغلاديش',
    'BB': 'باربادوس',
    'BY': 'بيلاروسيا',
    'BE': 'بلجيكا',
    'BZ': 'بليز',
    'BJ': 'بنين',
    'BT': 'بوتان',
    'BO': 'بوليفيا',
    'BA': 'البوسنة والهرسك',
    'BW': 'بوتسوانا',
    'BR': 'البرازيل',
    'BN': 'بروناي',
    'BG': 'بلغاريا',
    'BF': 'بوركينا فاسو',
    'BI': 'بوروندي',
    'CV': 'الرأس الأخضر',
    'KH': 'كمبوديا',
    'CM': 'الكاميرون',
    'CA': 'كندا',
    'CF': 'جمهورية إفريقيا الوسطى',
    'TD': 'تشاد',
    'CL': 'تشيلي',
    'CN': 'الصين',
    'CO': 'كولومبيا',
    'KM': 'جزر القمر',
    'CG': 'الكونغو',
    'CD': 'جمهورية الكونغو الديمقراطية',
    'CR': 'كوستاريكا',
    'CI': 'ساحل العاج',
    'HR': 'كرواتيا',
    'CU': 'كوبا',
    'CY': 'قبرص',
    'CZ': 'التشيك',
    'DK': 'الدنمارك',
    'DJ': 'جيبوتي',
    'DM': 'دومينيكا',
    'DO': 'جمهورية الدومينيكان',
    'EC': 'الإكوادور',
    'EG': 'مصر',
    'SV': 'السلفادور',
    'GQ': 'غينيا الاستوائية',
    'ER': 'إريتريا',
    'EE': 'إستونيا',
    'ET': 'إثيوبيا',
    'FJ': 'فيجي',
    'FI': 'فنلندا',
    'FR': 'فرنسا',
    'GA': 'الغابون',
    'GM': 'غامبيا',
    'GE': 'جورجيا',
    'DE': 'ألمانيا',
    'GH': 'غانا',
    'GR': 'اليونان',
    'GD': 'غرينادا',
    'GT': 'غواتيمالا',
    'GN': 'غينيا',
    'GW': 'غينيا بيساو',
    'GY': 'غيانا',
    'HT': 'هايتي',
    'HN': 'هندوراس',
    'HU': 'هنغاريا',
    'IS': 'آيسلندا',
    'IN': 'الهند',
    'ID': 'إندونيسيا',
    'IR': 'إيران',
    'IQ': 'العراق',
    'IE': 'أيرلندا',
    'IL': 'إسرائيل',
    'IT': 'إيطاليا',
    'JM': 'جامايكا',
    'JP': 'اليابان',
    'JO': 'الأردن',
    'KZ': 'كازاخستان',
    'KE': 'كينيا',
    'KI': 'كيريباتي',
    'KP': 'كوريا الشمالية',
    'KR': 'كوريا الجنوبية',
    'KW': 'الكويت',
    'KG': 'قيرغيزستان',
    'LA': 'لاوس',
    'LV': 'لاتفيا',
    'LB': 'لبنان',
    'LS': 'ليسوتو',
    'LR': 'ليبيريا',
    'LY': 'ليبيا',
    'LI': 'ليختنشتاين',
    'LT': 'ليتوانيا',
    'LU': 'لوكسمبورغ',
    'MG': 'مدغشقر',
    'MW': 'مالاوي',
    'MY': 'ماليزيا',
    'MV': 'المالديف',
    'ML': 'مالي',
    'MT': 'مالطا',
    'MH': 'جزر مارشال',
    'MR': 'موريتانيا',
    'MU': 'موريشيوس',
    'MX': 'المكسيك',
    'FM': 'ميكرونيزيا',
    'MD': 'مولدوفا',
    'MC': 'موناكو',
    'MN': 'منغوليا',
    'ME': 'الجبل الأسود',
    'MA': 'المغرب',
    'MZ': 'موزمبيق',
    'MM': 'ميانمار',
    'NA': 'ناميبيا',
    'NR': 'ناورو',
    'NP': 'نيبال',
    'NL': 'هولندا',
    'NZ': 'نيوزيلندا',
    'NI': 'نيكاراغوا',
    'NE': 'النيجر',
    'NG': 'نيجيريا',
    'MK': 'مقدونيا الشمالية',
    'NO': 'النرويج',
    'OM': 'عمان',
    'PK': 'باكستان',
    'PW': 'بالاو',
    'PS': 'فلسطين',
    'PA': 'بنما',
    'PG': 'بابوا غينيا الجديدة',
    'PY': 'باراغواي',
    'PE': 'بيرو',
    'PH': 'الفلبين',
    'PL': 'بولندا',
    'PT': 'البرتغال',
    'QA': 'قطر',
    'RO': 'رومانيا',
    'RU': 'روسيا',
    'RW': 'رواندا',
    'KN': 'سانت كيتس ونيفيس',
    'LC': 'سانت لوسيا',
    'VC': 'سانت فينسنت والغرينادين',
    'WS': 'ساموا',
    'SM': 'سان مارينو',
    'ST': 'ساو تومي وبرينسيبي',
    'SA': 'السعودية',
    'SN': 'السنغال',
    'RS': 'صربيا',
    'SC': 'سيشيل',
    'SL': 'سيراليون',
    'SG': 'سنغافورة',
    'SK': 'سلوفاكيا',
    'SI': 'سلوفينيا',
    'SB': 'جزر سليمان',
    'SO': 'الصومال',
    'ZA': 'جنوب إفريقيا',
    'SS': 'جنوب السودان',
    'ES': 'إسبانيا',
    'LK': 'سريلانكا',
    'SD': 'السودان',
    'SR': 'سورينام',
    'SZ': 'إسواتيني',
    'SE': 'السويد',
    'CH': 'سويسرا',
    'SY': 'سوريا',
    'TJ': 'طاجيكستان',
    'TZ': 'تنزانيا',
    'TH': 'تايلاند',
    'TL': 'تيمور الشرقية',
    'TG': 'توغو',
    'TO': 'تونغا',
    'TT': 'ترينيداد وتوباغو',
    'TN': 'تونس',
    'TR': 'تركيا',
    'TM': 'تركمانستان',
    'TV': 'توفالو',
    'UG': 'أوغندا',
    'UA': 'أوكرانيا',
    'AE': 'الإمارات العربية المتحدة',
    'GB': 'المملكة المتحدة',
    'US': 'الولايات المتحدة',
    'UY': 'أوروغواي',
    'UZ': 'أوزبكستان',
    'VU': 'فانواتو',
    'VA': 'مدينة الفاتيكان',
    'VE': 'فنزويلا',
    'VN': 'فيتنام',
    'YE': 'اليمن',
    'ZM': 'زامبيا',
    'ZW': 'زيمبابوي'
  },
  verification: {
    verifying: 'جاري التحقق من بريدك الإلكتروني...',
    success: 'تم التحقق من البريد الإلكتروني بنجاح!',
    failed: 'فشل التحقق',
    accountVerified: 'تم التحقق من حسابك بنجاح. يمكنك الآن تسجيل الدخول إلى حسابك.',
    invalidLink: 'رابط التحقق غير صالح أو منتهي الصلاحية.',
    missingToken: 'رمز التحقق مفقود.',
    generalError: 'حدث خطأ أثناء التحقق. يرجى المحاولة مرة أخرى لاحقًا.',
    proceedToLogin: 'المتابعة إلى تسجيل الدخول',
    backToLogin: 'العودة إلى تسجيل الدخول'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'لوحة التحكم',
    system: 'النظام',
    settings: 'الإعدادات',
    overview: 'نظرة عامة',
    database: 'قاعدة البيانات',
    logs: 'السجلات',
    userManagement: 'إدارة المستخدمين',
    security: 'الأمان',
    systemAdministration: 'إدارة النظام',
    loading: 'جاري التحميل...',
    close: 'إغلاق لوحة التحكم',
    edit: 'تعديل',
    systemUptime: 'مدة تشغيل النظام',
    avgResponseTime: 'متوسط وقت الاستجابة',
    errorRate: 'معدل الخطأ',
    activeUsers: 'المستخدمون النشطون',
    monthlyActiveUsers: 'المستخدمون النشطون شهريًا (MAU)',
    fromLastMonth: 'من الشهر الماضي',
    today: 'اليوم',
    tabs: {
      overview: 'صحة النظام',
      hierarchy: 'هرمية المعرفة', // NEW
      documents: 'إدارة المستندات', // NEW
      database: 'قاعدة البيانات',
      logs: 'السجلات',
      security: 'الأمان',
      users: 'المستخدمون'
    },
    // --- NEW KEYS ---
    contentManagement: "إدارة المحتوى",
    knowledgeHierarchy: "هرمية المعرفة",
    documentManagement: "إدارة المستندات",
    noLogsFound: "لم يتم العثور على سجلات لليوم",
    invalidLogsResponse: "هيكل استجابة ملخص السجلات غير صالح",
    logsSummaryError: "فشل تحميل ملخص السجلات",
    buttons: {
      save: "حفظ",
      cancel: "إلغاء",
      switch: "التبديل على أي حال",
      discard: "تجاهل"
    },
    confirm: {
      defaultTitle: "تأكيد",
      defaultMessage: "هل أنت متأكد؟"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: 'حالة صحة النظام',
    runDiagnostics: 'تشغيل التشخيص',
    resourceUsage: 'استخدام الموارد',
    services: {
      apiServices: 'خدمات API',
      database: 'قاعدة البيانات',
      cache: 'الذاكرة المؤقتة',
      storage: 'التخزين',
      messageQueue: 'قائمة الرسائل',
      externalApi: 'API خارجي'
    },
    resources: {
      cpu: 'استخدام وحدة المعالجة المركزية',
      memory: 'استخدام الذاكرة',
      storage: 'استخدام التخزين',
      network: 'عرض النطاق الترددي للشبكة'
    },
    databaseManagement: 'إدارة قاعدة البيانات',
    reindexDatabase: 'إعادة فهرسة قاعدة البيانات',
    lastReindex: 'آخر إعادة فهرسة',
    databaseSize: 'حجم قاعدة البيانات',
    totalTables: 'إجمالي الجداول',
    logManagement: 'إدارة السجلات',
    rolloverLogs: 'تدوير السجلات',
    searchLogs: 'البحث في السجلات',
    logTime: 'الوقت',
    logLevel: 'المستوى',
    logService: 'الخدمة',
    logMessage: 'الرسالة',
    showingEntries: 'إظهار {start}-{end} من {total} مدخلات',
    logLevels: {
      error: 'خطأ',
      warn: 'تحذير',
      info: 'معلومات',
      debug: 'تصحيح'
    },
    logMessages: {
      connectionTimeout: 'انتهاء مهلة الاتصال بالمزود الخارجي',
      lowDiskSpace: 'مساحة القرص أقل من عتبة 10%',
      userRoleUpdated: 'تم تحديث دور المستخدم لـ admin@huduma.ai'
    },
    userName: 'الاسم',
    userEmail: 'البريد الإلكتروني',
    userRole: 'الدور',
    userStatus: 'الحالة',
    userActions: 'الإجراءات',
    roleAdministrator: 'مدير',
    roleUser: 'مستخدم',
    statusActive: 'نشط',
    dbActions: {
      reindex: 'إعادة فهرسة',
      backup: 'نسخ احتياطي',
      optimize: 'تحسين',
      reindexDesc: 'إعادة بناء فهارس قاعدة البيانات',
      backupDesc: 'إنشاء نسخة احتياطية لقاعدة البيانات',
      optimizeDesc: 'تحسين أداء الاستعلام'
    },
    operations: {
      reindexTitle: 'نتائج إعادة فهرسة قاعدة البيانات',
      backupTitle: 'نتائج النسخ الاحتياطي لقاعدة البيانات',
      optimizeTitle: 'نتائج تحسين قاعدة البيانات',
      reindexResults: 'نتائج إعادة الفهرسة',
      optimizeResults: 'نتائج التحسين',
      collection: 'المجموعة',
      status: 'الحالة',
      indexSuggestions: 'اقتراحات الفهرس',
      backupDetails: 'تفاصيل النسخ الاحتياطي',
      backupFile: 'ملف النسخ الاحتياطي',
      backupLocation: 'الموقع',
      backupSize: 'الحجم',
      errorDetails: 'تفاصيل الخطأ',
      close: 'إغلاق',
      resultsTitle: 'نتائج العملية',
      reindexDatabase: {
        success: 'تم إكمال إعادة فهرسة قاعدة البيانات بنجاح',
        error: 'خطأ أثناء إعادة فهرسة قاعدة البيانات',
        loading: 'جاري إعادة فهرسة قاعدة البيانات...'
      },
      backupDatabase: {
        success: 'تم إكمال النسخ الاحتياطي لقاعدة البيانات بنجاح',
        error: 'خطأ أثناء النسخ الاحتياطي لقاعدة البيانات',
        loading: 'جاري النسخ الاحتياطي لقاعدة البيانات...'
      },
      optimizeDatabase: {
        success: 'تم إكمال تحسين قاعدة البيانات بنجاح',
        error: 'خطأ أثناء تحسين قاعدة البيانات',
        loading: 'جاري تحسين قاعدة البيانات...'
      },
      rolloverLogs: {
        success: 'تم إكمال تدوير السجلات بنجاح',
        loading: 'جاري تدوير السجلات...'
      },
      searchLogs: {
        success: 'تم إكمال البحث في السجلات',
        loading: 'جاري البحث في السجلات...'
      },
      runDiagnostics: {
        success: 'تم إكمال التشخيص بنجاح',
        loading: 'جاري تشغيل التشخيص...'
      },
      runSecurityScan: {
        success: 'تم إكمال فحص الأمان بنجاح',
        loading: 'جاري تشغيل فحص الأمان...'
      },
      cancel: 'إلغاء',
      save: 'حفظ التغييرات'
    },
    userManagementSection: {
      totalUsers: 'إجمالي المستخدمين',
      newUsers: 'مستخدمون جدد (شهر)',
      searchUsers: 'البحث عن المستخدمين...',
      clearSearch: 'مسح البحث',
      search: 'بحث',
      usersFound: 'مستخدمين تم العثور عليهم',
      showAllUsers: 'إظهار جميع المستخدمين',
      searching: 'جاري البحث...',
      searchingUsers: 'جاري البحث عن المستخدمين...',
      noUsersFound: 'لم يتم العثور على مستخدمين مطابقين لمعايير البحث الخاصة بك.',
      noUsers: 'لا يوجد مستخدمين متاحين.',
      showing: 'إظهار',
      of: 'من',
      previous: 'السابق',
      next: 'التالي',
      searchFields: {
        all: 'جميع الحقول',
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        role: 'الدور'
      },
      userSearch: {
        resultsFound: 'تم العثور على {total} مستخدمين مطابقين لـ "{term}"',
        error: 'خطأ في البحث عن المستخدمين'
      }
    },
    logsSection: {
      errorLogs: 'سجلات الأخطاء',
      warningLogs: 'سجلات التحذيرات',
      noErrorLogs: 'لم يتم تسجيل سجلات أخطاء اليوم.',
      noWarningLogs: 'لم يتم تسجيل سجلات تحذيرات اليوم.',
      infoLogsNote: 'سجلات المعلومات لا تظهر في الملخص. استخدم وظيفة البحث لعرض جميع أنواع السجلات.',
      searchResults: 'أحدث نتائج البحث',
      entriesFound: 'مدخلات تم العثور عليها',
      viewAllResults: 'عرض جميع النتائج',
      logType: 'النوع',
      logCount: 'العدد',
      logTypes: {
        connectionTimeout: 'انتهاء مهلة الاتصال',
        databaseFailed: 'فشل استعلام قاعدة البيانات',
        authFailed: 'فشل المصادقة',
        lowDiskSpace: 'مساحة القرص أقل من العتبة',
        slowQuery: 'أداء استعلام بطيء',
        rateLimit: 'الاقتراب من حد السرعة'
      },
      logSearch: {
        noResultsFound: 'لم يتم العثور على سجلات مطابقة لمعايير البحث الخاصة بك',
        resultsFound: 'تم العثور على {count} مدخلات سجل'
      }
    },
    security: {
      title: 'مراقبة الأمان',
      securityScan: 'فحص الأمان',
      runningSecurityScan: 'جاري تشغيل الفحص...',
      lastSecurityScan: 'آخر فحص أمان',
      vulnerabilitiesFound: 'الثغرات الأمنية المكتشفة',
      daysAgo: 'أيام مضت',
      critical: 'حرج',
      medium: 'متوسط',
      low: 'منخفض',
      failedLoginAttempts: 'محاولات تسجيل الدخول الفاشلة (24 ساعة)',
      suspiciousActivities: 'الأنشطة المشبوهة (24 ساعة)',
      securityRecommendations: 'توصيات الأمان',
      criticalVulnerabilities: 'الثغرات الأمنية الحرجة',
      mediumVulnerabilities: 'الثغرات الأمنية المتوسطة',
      lowVulnerabilities: 'الثغرات الأمنية المنخفضة',
      authenticationIssues: 'مشكلات المصادقة',
      suspiciousActivityLogs: 'سجلات الأنشطة المشبوهة',
      securityProbeAttempts: 'تم اكتشاف محاولات استكشاف الأمان',
      sensitiveFileAccess: 'تم اكتشاف محاولات الوصول إلى ملفات أو نقاط نهاية حساسة',
      envFileAccess: 'محاولات الوصول إلى ملفات البيئة',
      envFileAccessDesc: 'تم اكتشاف محاولات الوصول إلى ملفات .env',
      gitRepoAccess: 'محاولات الوصول إلى مستودع Git',
      gitRepoAccessDesc: 'تم اكتشاف محاولات الوصول إلى ملفات مستودع Git',
      recommendedAction: 'الإجراء الموصى به',
      rateLimitRecommendation: 'فكر في تطبيق حدود السرعة، وحظر عناوين IP للمخالفين المستمرين، وتأكد من وجود تصلب مناسب للخادم.',
      envFileRecommendation: 'تأكد من أن ملفات البيئة غير متاحة من دلائل الويب وأن تكوينات الخادم تمنع الوصول إلى الملفات الحساسة بشكل صحيح.',
      gitRepoRecommendation: 'تأكد من أن أدلة .git مؤمنة بشكل صحيح وغير متاحة من الويب.',
      noVulnerabilitiesFound: 'لم يتم العثور على ثغرات أمنية',
      systemSecure: 'يبدو نظامك آمنًا. واصل المراقبة بانتظام.',
      loadingScan: 'جاري تحميل نتائج الفحص...',
      occurrences: 'الحالات',
      firstSeen: 'تم رؤيته أول مرة',
      lastSeen: 'تم رؤيته آخر مرة',
      timestamp: 'الطابع الزمني',
      message: 'الرسالة',
      service: 'الخدمة',
      type: 'النوع',
      severity: 'الشدة',
      url: 'رابط URL',
      matchedTerm: 'المصطلح المتطابق',
      lineNumber: 'رقم السطر',
      lineNumbers: 'أرقام الأسطر',
      showLess: 'إظهار أقل',
      showMore: 'إظهار جميع المشكلات',
      // --- NEW KEY ---
      lastScanJustNow: "الآن"
    },
    userEdit: {
      title: 'تعديل المستخدم',
      loading: 'جاري تحميل بيانات المستخدم...',
      userInfo: 'معلومات المستخدم',
      userId: 'معرف المستخدم',
      loginName: 'اسم تسجيل الدخول',
      fullName: 'الاسم الكامل',
      dob: 'تاريخ الميلاد',
      email: 'البريد الإلكتروني',
      emailVerified: 'تم التحقق من البريد الإلكتروني',
      verified: 'تم التحقق',
      notVerified: 'لم يتم التحقق',
      createdAt: 'تم الإنشاء',
      lastLogin: 'آخر تسجيل دخول',
      never: 'أبدًا',
      accountSettings: 'إعدادات الحساب',
      accountStatus: 'حالة الحساب',
      accountEnabled: 'الحساب مفعل',
      cannotDisableSelf: 'لا يمكنك تعطيل حسابك الخاص',
      accountRole: 'دور الحساب',
      adminRole: 'دور المدير',
      cannotChangeOwnRole: 'لا يمكنك تغيير دورك الخاص',
      adminActions: 'إجراءات المدير',
      verifyEmail: 'التحقق من البريد الإلكتروني',
      resetPassword: 'إرسال إعادة تعيين كلمة المرور',
      forceLogout: 'فرض تسجيل الخروج',
      failedToLoad: 'فشل تحميل بيانات المستخدم',
      errorLoading: 'خطأ في تحميل بيانات المستخدم',
      saveSuccess: 'تم تحديث إعدادات المستخدم بنجاح',
      errorSaving: 'خطأ في حفظ إعدادات المستخدم',
      verifyEmailSuccess: 'تم إرسال بريد التحقق بنجاح',
      emailVerificationFailed: 'فشل إرسال بريد التحقق',
      errorVerifyingEmail: 'خطأ في إرسال بريد التحقق',
      passwordResetSent: 'تم إرسال بريد إعادة تعيين كلمة المرور',
      passwordResetFailed: 'فشل إرسال إعادة تعيين كلمة المرور',
      errorSendingReset: 'خطأ في إرسال إعادة تعيين كلمة المرور',
      logoutForced: 'تم تسجيل خروج المستخدم',
      logoutFailed: 'فشل فرض تسجيل الخروج',
      errorForcingLogout: 'خطأ في فرض تسجيل الخروج',
      // --- NEW KEY ---
      userUpdated: "تم تحديث المستخدم بنجاح"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: "إدارة هرمية المعرفة (ملاحظة: دائماً باللغة الإنجليزية - أضف ترجمات)",
      addCategory: "إضافة فئة جديدة",
      loading: "جاري تحميل الهرمية...",
      addService: "إضافة خدمة",
      editCategory: "تعديل الفئة",
      deleteCategory: "حذف الفئة",
      editService: "تعديل الخدمة",
      deleteService: "حذف الخدمة",
      empty: 'لم يتم العثور على فئات. انقر فوق "إضافة فئة جديدة" للبدء.',
      formTitleCreateCategory: "إنشاء فئة جديدة",
      formTitleAddService: 'إضافة خدمة إلى "{categoryName}"',
      formTitleEditCategory: 'تعديل الفئة: "{itemName}"',
      formTitleEditService: 'تعديل الخدمة: "{itemName}"',
      nameEnLabel: "الاسم (الإنجليزية)",
      translationsTitle: "ترجمات للعرض",
      loadingTranslations: "جاري تحميل الترجمات...",
      selectLang: "اختر اللغة",
      translationPlaceholder: "أدخل الترجمة",
      deleteTranslation: "حذف الترجمة",
      addTranslation: "+ إضافة ترجمة",
      saveSuccess: "تم حفظ عنصر الهرمية بنجاح.",
      saveError: "فشل حفظ عنصر الهرمية.",
      loadError: "فشل تحميل هرمية المعرفة.",
      loadTranslationsError: "فشل تحميل الترجمات.",
      confirmCancelTitle: "تغييرات غير محفوظة",
      confirmCancelEdit: "لديك تغييرات غير محفوظة سيتم فقدانها. هل أنت متأكد أنك تريد التبديل؟",
      confirmDeleteTitleCategory: "حذف الفئة؟",
      confirmDeleteTitleService: "حذف الخدمة؟",
      confirmDeleteCategory: 'هل أنت متأكد أنك تريد حذف الفئة "{itemName}"؟ لا يمكن التراجع عن هذا الإجراء.',
      confirmDeleteService: 'هل أنت متأكد أنك تريد حذف الخدمة "{itemName}"؟ لا يمكن التراجع عن هذا الإجراء.',
      deleteSuccessCategory: "تم حذف الفئة بنجاح.",
      deleteSuccessService: "تم حذف الخدمة بنجاح.",
      deleteErrorCategory: "فشل حذف الفئة.",
      deleteErrorService: "فشل حذف الخدمة.",
      duplicateLangError: "تم العثور على لغات مكررة في الترجمات. يرجى إزالتها."
    },
    // --- NEW OBJECT ---
    documents: {
      title: "إدارة المستندات",
      addLink: "إضافة من رابط",
      uploadFiles: "تحميل الملفات",
      searchPlaceholder: "البحث حسب اسم الملف...",
      allStatuses: "جميع الحالات",
      statusPending: "قيد الانتظار",
      statusIngested: "تم الاستيعاب",
      statusRetracted: "تم السحب",
      // --- NEW STATUSES ADDED ---
      statusIngesting: "قيد الاستيعاب",
      statusError: "خطأ في الاستيعاب",
      statusWarning: "تم الاستيعاب مع تحذيرات",
      // ---
      ingestSelected: "استيعاب المختار",
      colFileName: "اسم الملف",
      colStatus: "الحالة",
      colLabels: "العلامات",
      colUploadDate: "تاريخ الرفع",
      colSize: "الحجم",
      loading: "جاري تحميل المستندات...",
      empty: "لم يتم العثور على مستندات.",
      loadError: "فشل تحميل المستندات.",
      confirmIngestTitle: "تأكيد الاستيعاب الدفعي",
      ingest: "استيعاب",
      confirmIngestSelected: "هل أنت متأكد أنك تريد استيعاب {count} ملف(ات) مختارة؟",
      ingestQueuedSuccess: "تم وضع {count} ملف(ات) في قائمة الانتظار للاستيعاب.",
      ingestQueuedError: "حدث خطأ أثناء عملية الاستيعاب الدفعي.",
      uploadSuccessMultiple: "تم تحميل {count} ملف(ات) بنجاح.",
      linkSubmitSuccess: 'تم الزحف وحفظ "{fileName}" بنجاح.',
      actionSuccess: 'الإجراء "{action}" على الملف {fileId} كان ناجحًا.',
      metadataUpdateSuccess: "تم تحديث البيانات الوصفية للملف {fileId}."
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'إنشاء كلمة مرور جديدة',
    tokenLabel: 'رمز إعادة التعيين',
    tokenPlaceholder: 'أدخل رمز إعادة التعيين',
    validateButton: 'التحقق من الرمز',
    newPasswordLabel: 'كلمة المرور الجديدة',
    newPasswordPlaceholder: 'إنشاء كلمة مرور جديدة',
    confirmNewPasswordLabel: 'تأكيد كلمة المرور الجديدة',
    confirmNewPasswordPlaceholder: 'تأكيد كلمة المرور الجديدة',
    resetButton: 'إعادة تعيين كلمة المرور',
    processing: 'جاري إعادة التعيين...',
    rememberedPassword: 'هل تذكرت كلمة المرور؟',
    backToLogin: 'العودة إلى تسجيل الدخول',
    supportMessage: 'هل تحتاج إلى مساعدة؟ تواصل مع فريق الدعم الخاص بنا',
    passwordRequirements: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل مع رقم واحد على الأقل، وحرف كبير واحد، وأحد الرموز الخاصة',
    passwordsDoNotMatch: 'كلمات المرور غير متطابقة',
    resetSuccess: 'تم إعادة تعيين كلمة المرور بنجاح',
    resetFailed: 'غير قادر على إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.',
    noTokenProvided: 'يرجى تقديم رمز إعادة التعيين',
    expiredToken: 'انتهت صلاحية رمز إعادة التعيين هذا. يرجى طلب واحد جديد.',
    invalidToken: 'رمز إعادة التعيين غير صالح أو غير معروف',
    validatingToken: 'جاري التحقق من الرمز...',
    redirecting: 'جاري إعادة التوجيه إلى صفحة تسجيل الدخول...',
    passwordStrength: 'قوة كلمة المرور',
    strengthLabels: {
      veryWeak: 'ضعيف جدًا',
      weak: 'ضعيف',
      fair: 'متوسط',
      good: 'جيد',
      strong: 'قوي'
    },
    passwordSuggestions: {
      atLeast8Chars: 'استخدم 8 أحرف على الأقل',
      addUppercase: 'أضف أحرفًا كبيرة',
      addLowercase: 'أضف أحرفًا صغيرة',
      addNumbers: 'أضف أرقامًا',
      addSpecialChars: 'أضف رموزًا خاصة'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'إعادة تعيين كلمة المرور الخاصة بك',
    emailLabel: 'عنوان البريد الإلكتروني',
    emailPlaceholder: 'أدخل بريدك الإلكتروني',
    resetButton: 'إرسال رابط إعادة التعيين',
    processing: 'جاري الإرسال...',
    rememberPassword: 'هل تذكرت كلمة المرور؟',
    backToLogin: 'العودة إلى تسجيل الدخول',
    supportMessage: 'هل تحتاج إلى مساعدة؟ تواصل مع فريق الدعم الخاص بنا',
    invalidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح',
    resetRequestSuccess: 'تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني',
    resetRequestFailed: 'غير قادر على إرسال رابط إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.',
    checkEmail: 'يرجى التحقق من بريدك الإلكتروني للحصول على مزيد من التعليمات.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "إنشاء حساب جديد",
    username: "اسم المستخدم",
    usernamePlaceholder: "أدخل اسم المستخدم",
    email: "البريد الإلكتروني",
    emailPlaceholder: "أدخل بريدك الإلكتروني",
    password: "كلمة المرور",
    passwordPlaceholder: "إنشاء كلمة مرور",
    confirmPassword: "تأكيد كلمة المرور",
    confirmPasswordPlaceholder: "تأكيد كلمة المرور الخاصة بك",
    acceptTerms: "أوافق على",
    termsOfService: "شروط الخدمة",
    registerButton: "إنشاء حساب",
    processing: "جاري المعالجة...",
    alreadyHaveAccount: "هل لديك حساب بالفعل؟",
    loginNow: "تسجيل الدخول",
    privacyNotice: "بالتسجيل، فإنك توافق على شروط الخدمة وسياسة الخصوصية الخاصة بنا",
    usernameMinLength: "يجب أن يتكون اسم المستخدم من 3 أحرف على الأقل",
    invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صالح",
    passwordRequirements: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل مع رقم واحد على الأقل وحرف كبير واحد",
    passwordsDoNotMatch: "كلمات المرور غير متطابقة",
    mustAcceptTerms: "يجب أن توافق على شروط الخدمة",
    registrationFailed: "فشل التسجيل. يرجى المحاولة مرة أخرى.",
    usernameExists: "اسم المستخدم موجود بالفعل",
    emailExists: "البريد الإلكتروني موجود بالفعل",
    registrationSuccess: "التسجيل ناجح!",
    verificationEmailSent: "تم إرسال بريد إلكتروني للتحقق إلى {email}",
    checkEmailInstructions: "يرجى التحقق من بريدك الإلكتروني واتباع التعليمات للتحقق من حسابك قبل تسجيل الدخول.",
    backToLogin: "العودة إلى تسجيل الدخول",
    noEmailReceived: "لم تتلقَ بريدًا إلكترونيًا؟",
    resendVerification: "إعادة إرسال بريد التحقق",
    verificationResent: "تم إعادة إرسال بريد التحقق",
    verificationResendFailed: "فشل إعادة إرسال بريد التحقق. يرجى المحاولة مرة أخرى.",
    usernameInvalidChars: 'يمكن أن يحتوي اسم المستخدم فقط على أحرف، أرقام، خطوط سفلية، نقاط وواصلات',
    networkError: 'خطأ في الشبكة. يرجى التحقق من اتصالك والمحاولة مرة أخرى.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    loginButton: 'تسجيل الدخول',
    or: 'أو',
    savedAccounts: 'الحسابات المحفوظة',
    loginSuccess: 'تسجيل الدخول ناجح',
    loginError: 'فشل تسجيل الدخول. يرجى التحقق من بيانات الاعتماد الخاصة بك.',
    googleLogin: 'المتابعة مع Google',
    facebookLogin: 'المتابعة مع Facebook',
    rememberMe: 'تذكرني',
    forgotPassword: 'هل نسيت كلمة المرور؟',
    noAccount: 'ليس لديك حساب؟',
    createAccount: 'إنشاء حساب',
    registerNow: "سجل الآن",
    termsAndPolicy: 'بتسجيل الدخول، فإنك توافق على شروط الخدمة وسياسة الخصوصية الخاصة بنا',
    loggingIn: "جاري تسجيل الدخول...",
    fieldsRequired: "اسم المستخدم وكلمة المرور مطلوبان",
    invalidCredentials: "اسم المستخدم أو كلمة المرور غير صالحة",
    tooManyAttempts: "محاولات تسجيل الدخول كثيرة جدًا. يرجى المحاولة مرة أخرى لاحقًا.",
    loginFailed: "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
    oauthNotImplemented: "تسجيل الدخول الاجتماعي لم يتم تنفيذه بعد",
    savedLoginNotImplemented: "تسجيل الدخول بحساب محفوظ لم يتم تنفيذه بعد"
  },
  charts: {
    tooltip: {
      title: 'التاريخ',
      totalQueries: 'إجمالي الاستعلامات',
      uniqueUsers: 'المستخدمون الفريدون'
    },
    day: 'يوم',
    noData: 'لا توجد بيانات',
    notAvailable: 'غير متاح',
    topQueries: 'أهم الاستعلامات',
    categoryDistribution: 'الاستخدام حسب مجال المعرفة',
    usageTrend: 'اتجاه الاستخدام'
  },
  analytics: {
    title: 'تحليل البيانات والرؤى',
    loading: 'جاري تحميل بيانات التحليل...',
    period: 'الفترة الزمنية',
    charts: {
      satisfactionHeatmap: "الرضا حسب مجال المعرفة",
      satisfactionSubtitle: "النسب المئوية للتقييمات عبر الزمن"
    },
    timePeriods: {
      week4: "قبل 4 أسابيع",
      week3: "قبل 3 أسابيع",
      week2: "قبل أسبوعين",
      week1: "الأسبوع الماضي",
      current: "الحالي"
    },
    errors: {
      loading: "فشل تحميل بيانات الرضا. يرجى المحاولة مرة أخرى.",
    },
    status: {
      loading: 'جاري التحميل...',
      noData: 'لا توجد بيانات متاحة لهذه الفترة',
      error: 'فشل تحميل بيانات التحليل',
      online: "النظام متصل",
      offline: "النظام غير متصل",
      responseTime: "متوسط وقت الاستجابة",
      queueLength: "القائمة",
      uptime: "مدة التشغيل"
    },
    periods: {
      daily: 'يومي',
      weekly: 'أسبوعي',
      monthly: 'شهري',
      allTime: 'كل الوقت'
    },
    metrics: {
      totalQueries: 'إجمالي الاستعلامات',
      uniqueUsers: 'المستخدمون الفريدون',
      avgResponseTime: 'متوسط وقت الاستجابة',
      satisfaction: 'رضا المستخدم'
    },
    table: {
      rank: 'الترتيب',
      query: 'الاستعلام',
      count: 'العدد',
      avgTime: 'متوسط الوقت'
    },
    chartLabels: {
      categories: 'المجالات',
      serviceCategories: 'مجالات المعرفة',
      byUsage: 'حسب الاستخدام',
      category: 'المجال'
    },
    tooltips: {
      selectPeriod: 'اختر الفترة الزمنية',
      selectDate: 'اختر التاريخ',
      exportData: 'تصدير البيانات'
    },
    gauge: {
      historical: 'الاتجاهات التاريخية',
      vsPrevious: 'مقارنة بالفترة السابقة',
      target: 'الهدف'
    },
    ratings: {
      poor: "ضعيف",
      average: "متوسط",
      good: "جيد",
      excellent: "ممتاز"
    },
    slower: 'أبطأ',
    faster: 'أسرع',
    percentage: 'النسبة المئوية',
    note: 'فيما يلي إحصاءات الاستخدام وملخصات تعليقات المستخدمين.',
    usageStats: 'إحصاءات الاستخدام',
    peakUsers: 'أعلى المستخدمين المتزامنين',
    activeChats: 'المحادثات النشطة',
    usageTrend: 'اتجاه الاستخدام',
    topQueries: 'أهم الاستعلامات',
    feedbackSamples: 'عينات تعليقات المستخدمين',
    close: 'إغلاق',
    chartComingSoon: 'سيتم إطلاق تصور الرسم البياني التفاعلي قريبًا...',
    retry: 'إعادة المحاولة',
    dailyQueries: 'الاستعلامات اليومية',
    export: 'تصدير البيانات',
    dateRange: 'نطاق التاريخ',
    startDate: 'تاريخ البدء',
    endDate: 'تاريخ الانتهاء',
    rank: 'الترتيب',
    query: 'الاستعلام',
    count: 'العدد',
    avgTime: 'متوسط الوقت',
    serviceUsage: 'الاستخدام حسب مجال المعرفة',
    usageTrends: 'اتجاهات الاستخدام',
    week: 'الأسبوع الماضي',
    month: 'الشهر الماضي',
    quarter: 'الربع الماضي',
    year: 'العام الماضي',
    uniqueUsers: 'المستخدمون الفريدون',
    satisfactionRate: 'معدل الرضا',
    satisfactionAnalysis: 'تحليل رضا المستخدم'
  },
  brandName: 'Genie AI: مساعدك الحكومي الرقمي',
  nav: {
    systemStatus: 'حالة النظام',
    menu: 'القائمة',
    analytics: 'التحليلات',
    userProfile: 'ملف المستخدم',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    profile: 'ملفي الشخصي',
    toggleSidebar: 'تبديل الشريط الجانبي',
    changeLanguage: 'تغيير اللغة',
    administration: "الإدارة",
    languages: {
      english: 'الإنجليزية',
      french: 'الفرنسية',
      swahili: 'السواحلية'
    }
  },
  systemStatus: {
    title: 'حالة الخدمة',
    services: 'الخدمات',
    operational: 'يعمل',
    degraded: 'متدهور',
    outage: 'انقطاع',
    allOperational: 'جميع الأنظمة',
    someIssues: 'بعض المشكلات',
    majorIssues: 'مشكلات كبيرة',
    checking: 'جاري التحقق...',
    nextDeadline: 'الموعد النهائي التالي',
    days: 'أيام',
    viewDetails: 'عرض التفاصيل'
  },
  services: {
    eCitizen: 'بوابة eCitizen',
    taxFiling: 'نظام تقديم الضرائب',
    idApplication: 'طلب الهوية',
    businessReg: 'تسجيل الأعمال',
    drivingLicense: 'رخصة القيادة'
  },
  deadlines: {
    taxFiling: 'الموعد النهائي لتقديم الضرائب',
    businessRenewal: 'تجديد ترخيص الأعمال',
    idRenewal: 'تجديد بطاقة الهوية',
    vehicleRegistration: 'الموعد النهائي لتسجيل المركبة'
  },
  sidebar: {
    governmentServices: 'مجالات المعرفة',
    chatHistory: 'سجل المحادثات',
    searchPlaceholder: 'البحث في مجالات المعرفة...',
    createFolder: 'إنشاء مجلد',
    editFolder: 'تعديل المجلد',
    folderName: 'اسم المجلد',
    folderNamePlaceholder: 'أدخل اسم المجلد',
    moveChat: 'نقل المحادثة',
    moveChatTo: 'نقل المحادثة إلى',
    selectFolder: 'اختر مجلدًا',
    deleteChat: 'حذف المحادثة',
    deleteChatConfirm: 'هل أنت متأكد من أنك تريد حذف هذه المحادثة؟',
    deleteChatWarning: 'هذا الإجراء لا يمكن التراجع عنه.',
    renameChat: "إعادة تسمية المحادثة",
    chatTitle: "عنوان المحادثة",
    chatTitlePlaceholder: "أدخل عنوانًا لهذه المحادثة",
    deleteFolder: "حذف المجلد",
    deleteFolderConfirm: "هل أنت متأكد من أنك تريد حذف المجلد '{name}'؟",
    chatsMoveWarning: "سيتم نقل جميع المحادثات في هذا المجلد إلى المجلد الافتراضي.",
    weatherTitle: "توقعات الطقس",
    weatherLoading: "جاري تحميل بيانات الطقس...",
    weatherError: "غير قادر على تحميل بيانات الطقس. يرجى المحاولة مرة أخرى.",
    weatherLocationLoading: 'جاري تحميل الموقع...',
    weatherErrorDefault: 'تعذر استرداد بيانات الطقس.',
    weatherGeolocationUnsupported: 'التحديد الجغرافي غير مدعوم من قبل متصفحك.',
    weatherRefresh: 'تحديث الطقس',
    weatherConditions: {
      clear: 'صاف',
      partlycloudy: 'غائم جزئياً',
      cloudy: 'غائم',
      overcast: 'غائم كلياً',
      rain: 'مطر',
      shower: 'زخات مطر',
      thunderstorm: 'عاصفة رعدية',
      snow: 'ثلج'
    },
    folders: "المجلدات",
    emptyFolder: "هذا المجلد فارغ. انقل المحادثات إلى هنا من قائمة المحادثات.",
    title: 'المعلومات والموارد',
    noChats: 'لا توجد محادثات حديثة',
    relatedDocs: 'الوثائق ذات الصلة',
    noDocuments: 'لا توجد وثائق ذات صلة',
    faq: 'الأسئلة الشائعة',
    tab: {
      all: 'جميع المحادثات',
      folders: 'المجلدات',
      starred: 'المميزة',
      archived: 'المحفوظة'
    },
    savedChats: 'المحادثات المحفوظة',
    chats: "المحادثات",
    allChats: "جميع المحادثات",
    noFolder: "لا يوجد مجلد",
    starredChats: "المحادثات المميزة",
    archivedChats: "المحادثات المحفوظة",
    noStarredChats: "لا توجد محادثات مميزة بعد. قم بتمييز محادثة لإضافتها هنا.",
    noArchivedChats: "لا توجد محادثات محفوظة بعد.",
    noSearchResults: 'لم يتم العثور على محادثات لـ "{term}"',
    loadingChats: "جاري تحميل المحادثات...",
    errorLoadingConversations: "فشل تحميل المحادثات. يرجى المحاولة مرة أخرى.",
    errorLoadingUser: "بيانات المستخدم غير مكتملة. يرجى إعادة تحميل الصفحة.",
    errorNoUser: "بيانات المستخدم مفقودة. يرجى إعادة تحميل الصفحة.",
    retry: "إعادة المحاولة",
    message: "رسالة",
    messages: "رسائل",
    created: "تم الإنشاء",
    updated: "تم التحديث",
    star: "تمييز",
    unstar: "إلغاء التمييز",
    archive: "أرشفة",
    chatStarred: "تم تمييز المحادثة",
    chatUnstarred: "تم إلغاء تمييز المحادثة",
    chatArchived: "تم أرشفة المحادثة",
    chatUnarchived: "تم إلغاء أرشفة المحادثة",
    errorUpdatingChat: "فشل تحديث المحادثة",
    chatRenamed: "تم إعادة تسمية المحادثة بنجاح",
    errorRenamingChat: "فشل إعادة تسمية المحادثة",
    chatDeleted: "تم حذف المحادثة بنجاح",
    errorDeletingChat: "فشل حذف المحادثة",
    chatMoved: "تم نقل المحادثة بنجاح",
    errorMovingChat: "فشل نقل المحادثة",
    noPreview: "لا يوجد معاينة متاحة",
    searchConversations: 'البحث في المحادثات...',
    selectFolderInstruction: "اختر مجلدًا لعرض محادثاته",
    folderCreated: "تم إنشاء المجلد بنجاح",
    errorCreatingFolder: "فشل إنشاء المجلد",
    errorLoadingFolders: "فشل تحميل المجلدات",
    folderUpdated: "تم تحديث المجلد بنجاح",
    errorUpdatingFolder: "فشل تحديث المجلد",
    folderDeleted: "تم حذف المجلد بنجاح",
    errorDeletingFolder: "فشل حذف المجلد",
    chatRemovedFromFolders: "تم إزالة المحادثة من المجلد",
    errorRemovingChat: "فشل إزالة المحادثة من المجلد",
    id: "هوية",
    labels: "تسميات",
    confidence: "ثقة",
    unknown: "مجهول"
  },
  leftPanel: {
    cat1: {
      name: '1. الهوية والتسجيل المدني',
      children: ['شهادات الميلاد', 'بطاقات الهوية الوطنية', 'جوازات السفر', 'شهادات الزواج والوفاة', 'تسجيل الناخبين']
    },
    cat2: {
      name: '2. الرعاية الصحية والخدمات الاجتماعية',
      children: ['الوصول إلى الرعاية الصحية العامة', 'برامج التطعيم', 'التأمين الصحي', 'إعانات الإعاقة', 'الرعاية الاجتماعية والمساعدات الغذائية']
    },
    cat3: {
      name: '3. التعليم والتعلم',
      children: ['المدارس والجامعات العامة', 'المنح الدراسية وقروض الطلاب', 'برامج تعليم الكبار', 'موارد التعلم عبر الإنترنت']
    },
    cat4: {
      name: '4. التوظيف والخدمات العمالية',
      children: ['البحث عن عمل وإعانات البطالة', 'حماية العمال وحقوق العمل', 'لوائح سلامة مكان العمل', 'التدريب على المهارات والتدريب المهني']
    },
    cat5: {
      name: '5. الضرائب والإيرادات',
      children: ['تقديم الضرائب على الدخل والاستردادات', 'مدفوعات ضريبة الأملاك', 'الامتثال لضريبة الأعمال', 'الجمارك وواجبات الاستيراد']
    },
    cat6: {
      name: '6. السلامة العامة والعدالة',
      children: ['الشرطة وخدمات الطوارئ', 'المحاكم والمساعدة القانونية', 'الإبلاغ عن الجرائم', 'قوانين حماية المستهلك']
    },
    cat7: {
      name: '7. النقل والتنقل',
      children: ["رخص القيادة وتسجيل المركبات", 'النقل العام والبنية التحتية', 'مخالفات المرور والغرامات', 'برامج سلامة الطرق']
    },
    cat8: {
      name: '8. الإسكان والتنمية الحضرية',
      children: ['المساعدة في الإسكان العام', 'تسجيل العقارات وسجلات الأراضي', 'قروض وإعانات الإسكان', 'التقسيم والتصاريح البنائية']
    },
    cat9: {
      name: '9. المرافق والبيئة',
      children: ['خدمات المياه والكهرباء', 'إدارة النفايات وإعادة التدوير', 'اللوائح البيئية', 'مبادرات الطاقة المتجددة']
    },
    cat10: {
      name: '10. الأعمال والتجارة',
      children: ['تسجيل الأعمال وترخيصها', 'لوائح التجارة والتصاريح', 'منح وحوافز الأعمال الصغيرة', 'دعم التجارة الإلكترونية والأعمال الرقمية']
    },
    cat11: {
      name: '11. الضمان الاجتماعي والمعاشات',
      children: ['إعانات التقاعد', 'إدارة صناديق المعاشات', 'إعانات الناجين', 'معاشات الإعاقة']
    },
    cat12: {
      name: '12. المجتمع والمشاركة المدنية',
      children: ['التصويت والانتخابات', 'ردود الفعل العامة وشكاوى المواطنين', 'التطوع وبرامج المجتمع', 'المشاركة في الحكومة المحلية']
    }
  },
  settings: {
    title: 'الإعدادات',
    save: 'حفظ',
    close: 'إغلاق',
    saveSettings: 'حفظ الإعدادات',
    savingSettings: "جاري حفظ إعداداتك...",
    settingsSaved: "تم حفظ الإعدادات بنجاح!",
    saveSuccess: 'تم حفظ الإعدادات بنجاح',
    saveError: 'خطأ في حفظ الإعدادات',
    display: 'العرض',
    displayLanguage: 'لغة العرض',
    languages: {
      english: 'الإنجليزية',
      french: 'الفرنسية',
      swahili: 'السواحلية'
    },
    theme: 'السمة',
    themes: {
      light: 'فاتح',
      dark: 'داكن',
      system: 'النظام'
    },
    fontSize: 'حجم الخط',
    notifications: 'الإشعارات',
    emailUpdates: 'تحديثات البريد الإلكتروني',
    soundNotifications: 'إشعارات الصوت',
    accountManagement: 'إدارة الحساب',
    emailAddress: 'عنوان البريد الإلكتروني',
    emailAddressPlaceholder: 'عنوان بريدك الإلكتروني',
    password: 'كلمة المرور',
    changePassword: 'تغيير كلمة المرور',
    resetUserData: 'إعادة تعيين بيانات المستخدم',
    resetUserDataDesc: 'سيؤدي هذا إلى مسح جميع بيانات ملفك الشخصي وسجل المحادثات.',
    deleteAccount: 'حذف الحساب',
    deleteAccountDesc: 'سيؤدي هذا إلى حذف حسابك وجميع البيانات المرتبطة به نهائيًا.',
    edit: 'تعديل',
    standardAccount: 'حساب قياسي',
    confirmEmailChange: 'تأكيد تغيير البريد الإلكتروني',
    pleaseEnterPassword: 'يرجى إدخال كلمة المرور الخاصة بك',
    cancel: 'إلغاء',
    account: {
      title: 'الحساب',
      resetDescription: 'سيؤدي هذا إلى مسح جميع بيانات ملفك الشخصي وسجل المحادثات.',
      confirmReset: 'هل أنت متأكد من أنك تريد إعادة تعيين جميع بياناتك؟ لا يمكن التراجع عن هذا الإجراء.',
      resetComplete: 'تم إعادة تعيين بياناتك.'
    },
    language: {
      title: 'اللغة',
      selectLabel: 'لغة العرض'
    },
    appearance: {
      title: 'المظهر',
      lightTheme: 'فاتح',
      darkTheme: 'داكن',
      systemTheme: 'النظام'
    },
    confirmDeleteAccount: 'هل أنت متأكد من أنك تريد حذف حسابك؟ لا يمكن التراجع عن هذا الإجراء.',
    confirmAccountDeletion: 'تأكيد حذف الحساب',
    accountDeletionWarning: 'تحذير: هذا الإجراء دائم ولا يمكن التراجع عنه. سيتم حذف جميع بياناتك نهائيًا.',
    deletionReason: 'سبب الحذف (اختياري):',
    deletionReasonPlaceholder: 'ما الذي جعلك تقرر حذف حسابك؟',
    enterPasswordConfirm: 'أدخل كلمة المرور الخاصة بك للتأكيد:',
    currentPasswordPlaceholder: 'كلمة المرور الحالية الخاصة بك',
    deleting: 'جاري الحذف...',
    permanentlyDeleteAccount: 'حذف الحساب',
    accountDeletedSuccess: 'تم حذف حسابك بنجاح.',
    incorrectPassword: 'كلمة المرور غير صحيحة',
    accountDeletionFailed: 'فشل حذف الحساب. يرجى المحاولة مرة أخرى لاحقًا.',
    confirmChange: 'تأكيد التغيير',
    processing: 'جاري المعالجة...',
    userDataReset: 'تم إعادة تعيين بيانات ملفك الشخصي بنجاح.',
    failedToResetUserData: 'فشل إعادة تعيين بيانات ملفك الشخصي. يرجى المحاولة مرة أخرى لاحقًا.',
    changingEmailTo: 'تغيير بريدك الإلكتروني إلى',
    will: 'سوف',
    logOutSystem: 'تسجيل خروجك من النظام',
    sendVerificationLink: 'إرسال رابط التحقق إلى بريدك الإلكتروني الجديد',
    requireVerification: 'يتطلب التحقق قبل أن تتمكن من تسجيل الدخول مرة أخرى',
    checkNewEmailVerification: 'يرجى التحقق من بريدك الإلكتروني الجديد للحصول على تعليمات التحقق.',
    unableToVerifyEmail: 'غير قادر على التحقق من البريد الإلكتروني. يرجى المحاولة مرة أخرى.',
    emailAlreadyInUse: 'البريد الإلكتروني مستخدم بالفعل',
    enterValidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح',
    failedToUpdateEmail: 'فشل تحديث البريد الإلكتروني. يرجى المحاولة مرة أخرى.',
    passwordResetInitiated: 'تم إرسال رابط إعادة تعيين كلمة المرور إلى عنوان بريدك الإلكتروني.',
    unableToLoadUser: 'غير قادر على تحميل معلومات المستخدم. يرجى المحاولة مرة أخرى.',
    retry: 'إعادة المحاولة',
    user: 'المستخدم',
    loadingUserInfo: 'جاري تحميل معلومات المستخدم...',
    resetUserDataTitle: "إعادة تعيين بيانات المستخدم",
    confirmResetUserData: "هل أنت متأكد من أنك تريد إعادة تعيين جميع بيانات ملفك الشخصي؟ سيؤدي هذا إلى مسح جميع معلومات ملفك الشخصي وسجل المحادثات، ولكن سيحتفظ ببيانات اعتماد حسابك.",
    reset: "إعادة التعيين",
    deleteAccountTitle: "حذف الحساب"
  },
  userProfile: {
    title: 'ملف المستخدم',
    privacyInfo: "من خلال تقديم المزيد من المعلومات، ستحصل على ردود أكثر دقة ومعنى من الروبوت الدردشة. يرجى مراجعة",
    privacyPolicyLink: 'سياسة الخصوصية',
    tabComingSoon: 'هذه التبويبة قيد التطوير وستكون متاحة قريبًا.',
    saveSuccess: 'تم حفظ الملف الشخصي بنجاح',
    loadError: 'خطأ في تحميل بيانات الملف الشخصي',
    saveError: 'خطأ في حفظ الملف الشخصي',
    confirmSaveTitle: "حفظ الملف الشخصي",
    confirmSave: "هل أنت متأكد من أنك تريد حفظ هذه التغييرات؟",
    confirmCancel: 'لديك تغييرات غير محفوظة. هل أنت متأكد من أنك تريد الإلغاء؟',
    confirmLeave: 'هل أنت متأكد من أنك تريد المغادرة؟ سيتم فقدان أي تغييرات غير محفوظة.',
    confirmDiscardChanges: 'هل تريد التخلص من التغييرات غير المحفوظة؟',
    uploadPhoto: 'تحميل الصورة',
    uploadFile: 'تحميل ملف',
    photoRequirements: 'يجب أن تكون الصورة واضحة، حديثة، وتظهر وجهك بالكامل',
    biometricRequirements: 'يتم قبول ملفات البيانات البيومترية الرسمية فقط',
    documentUpload: 'تحميل الوثيقة',
    validationTitle: 'يرجى تصحيح الأخطاء التالية:',
    profileIcon: 'أيقونة الملف الشخصي',
    change: 'تغيير',
    chooseProfileIcon: 'اختر أيقونة الملف الشخصي',
    presetIcons: 'أيقونات محددة مسبقًا',
    upload: 'تحميل',
    initials: 'الأحرف الأولى',
    clickToUpload: 'انقر للتحميل',
    useThisImage: 'استخدام هذه الصورة',
    useInitials: 'استخدام الأحرف الأولى',
    tabs: {
      tab1: 'بيانات التعريف الشخصي',
      tab2: 'التسجيل المدني والوثائق',
      tab3: 'معلومات العنوان والإقامة',
      tab4: 'وثائق الهوية والسفر',
      tab5: 'السجلات الصحية والطبية',
      tab6: 'بيانات التوظيف والاقتصاد',
      tab7: 'السجلات التعليمية والأكاديمية',
      tab8: 'البيانات المالية والضريبية',
      tab9: 'الضمان الاجتماعي والرعاية',
      tab10: 'السجلات الجنائية والقانونية',
      tab11: 'النقل والتنقل',
      tab12: 'المشاركة المدنية والسياسية'
    },
    actions: {
      cancel: 'إلغاء',
      save: 'حفظ الملف الشخصي',
      previous: 'السابق',
      next: 'التالي',
      saving: 'جاري الحفظ...'
    },
    fields: {
      fullName: 'الاسم الكامل (بما في ذلك الأسماء المستعارة)',
      dob: 'تاريخ الميلاد',
      gender: 'الجنس',
      nationality: 'الجنسية',
      maritalStatus: 'الحالة الزوجية',
      photograph: 'الصورة',
      biometric: 'بصمات الأصابع / البيانات البيومترية',
      birthCert: 'شهادة الميلاد',
      deathCert: 'شهادة الوفاة',
      marriageDivorce: 'سجلات الزواج / الطلاق',
      adoption: 'سجلات التبني',
      citizenship: 'وثائق الجنسية / التجنيس',
      immigration: 'تاريخ الهجرة والتأشيرات',
      currentAddress: 'العنوان السكني الحالي',
      previousAddresses: 'العناوين السابقة',
      postalCode: 'الرمز البريدي',
      country: 'البلد',
      residencyStatus: 'حالة الإقامة',
      homeOrRental: 'الملكية أو تفاصيل الإيجار',
      utilityBills: 'فواتير المرافق المرتبطة بالعنوان',
      landRecords: 'سجلات الأراضي والملكية',
      idCard: 'رقم بطاقة الهوية الوطنية',
      passport: 'تفاصيل جواز السفر',
      driversLicense: "رخصة القيادة",
      voterId: 'معرف الناخب',
      ssn: 'رقم الضمان الاجتماعي / التأمين الوطني',
      militaryRecords: 'سجلات الخدمة العسكرية',
      medicalHistory: 'التاريخ الطبي والحالات الصحية',
      vaccinations: 'سجلات التطعيم',
      insuranceDetails: 'تفاصيل التأمين الصحي',
      disability: 'حالة الإعاقة',
      bloodType: 'فصيلة الدم',
      organDonor: 'حالة متبرع الأعضاء',
      prescriptions: 'الوصفات والعلاجات المستلمة',
      mentalHealth: 'تاريخ الصحة العقلية',
      eHistory: 'تاريخ التوظيف',
      currentEmployer: 'تفاصيل صاحب العمل الحالي',
      workPermits: 'تصاريح العمل وعقود العمل',
      certifications: 'الشهادات المهنية والتراخيص',
      unemployment: 'حالة البطالة والإعانات المستلمة',
      tin: 'رقم تعريف دافع الضرائب (TIN)',
      businessAffiliations: 'ملكية الأعمال والانتماءات الشركات',
      schools: 'المدارس والجامعات التي تم الالتحاق بها',
      education: 'التعليم',
      degrees: 'الدبلومات، الدرجات، والشهادات',
      performance: 'الأداء الأكاديمي ونتائج الاختبارات',
      academicRecords: "السجلات الأكاديمية",
      scholarships: 'المنح الدراسية والمساعدات المالية المستلمة',
      incomeTax: 'سجلات ضريبة الدخل',
      bankAccounts: 'الحسابات البنكية والمالية',
      propertyTax: 'مدفوعات ضريبة الأملاك',
      businessTax: 'تسجيلات ضريبة الأعمال',
      pensionContrib: 'مساهمات المعاشات والسحوبات',
      loanAid: 'سجلات القروض والمساعدات الحكومية',
      pensionStatus: 'حالة المعاش والمساهمات',
      childcare: 'دعم رعاية الأطفال',
      foodAssistance: 'المساعدة الغذائية / برامج الرعاية',
      housingAssistance: 'المساعدة في الإسكان',
      policeRecords: 'سجلات الشرطة (التاريخ الجنائي، الاعتقالات، التهم)',
      courtCases: 'تاريخ القضايا القضائية',
      finesPenalties: 'الغرامات والعقوبات',
      paroleProbation: 'حالة الإفراج المشروط أو المراقبة',
      citizenshipRevocation: 'إلغاء الجنسية (إن وجد)',
      vehicleReg: 'تفاصيل تسجيل المركبة',
      trafficViolations: 'مخالفات المرور والغرامات',
      licenseHistory: 'تاريخ رخصة القيادة والتأييدات',
      publicTransportCard: 'استخدام بطاقة النقل العام',
      voterRegistration: 'تفاصيل تسجيل الناخبين',
      electionHistory: 'تاريخ المشاركة في الانتخابات',
      partyMembership: 'عضوية الحزب السياسي',
      militaryStatus: 'حالة الخدمة العسكرية أو التجنيد',
      publicServiceRoles: 'أدوار الخدمة العامة'
    },
    placeholders: {
      fullName: 'أدخل اسمك القانوني الكامل',
      nationality: 'أدخل جنسيتك',
      searchCountries: 'البحث عن البلدان...',
      selectCountry: 'اختر بلدًا',
      searchDisciplines: "البحث عن التخصصات...",
      selectDiscipline: "اختر تخصصًا",
      searchDegrees: "البحث عن الدرجات...",
      selectDegree: "اختر درجة"
    },
    validation: {
      nameRequired: 'الاسم الكامل مطلوب',
      dobRequired: 'تاريخ الميلاد مطلوب',
      dobFuture: 'لا يمكن أن يكون تاريخ الميلاد في المستقبل',
      requiredField: '{field} مطلوب',
      invalidFormat: 'تنسيق غير صالح لـ {field}',
      futureDate: 'لا يمكن أن يكون التاريخ في المستقبل',
      invalidSelection: 'يرجى اختيار خيار صالح',
      passwordLength: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
      matchError: 'الحقول غير متطابقة'
    },
    errors: {
      savingFailed: 'فشل حفظ الملف الشخصي',
      loadingFailed: 'فشل تحميل بيانات الملف الشخصي',
      invalidForm: 'يرجى ملء جميع الحقول المطلوبة',
      invalidFileType: 'نوع الملف غير صالح',
      fileTooLarge: 'الملف كبير جدًا',
      countryLoadError: 'خطأ في تحميل البلدان',
      countryUpdateError: 'خطأ في تحديث البلد'
    },
    notifications: {
      saveSuccess: 'تم حفظ الملف الشخصي بنجاح',
      saveFailed: 'فشل حفظ الملف الشخصي',
      loadSuccess: 'تم تحميل الملف الشخصي بنجاح',
      loadFailed: 'فشل تحميل الملف الشخصي',
      fieldRequired: 'هذا الحقل مطلوب',
      uploadSuccess: 'تم تحميل الملف بنجاح',
      uploadFailed: 'فشل تحميل الملف',
      formChanged: 'لديك تغييرات غير محفوظة',
      sessionExpired: 'انتهت صلاحية جلستك، يرجى تسجيل الدخول مرة أخرى',
      profileUpdated: 'تم تحديث ملفك الشخصي',
      profileIncomplete: 'ملفك الشخصي غير مكتمل'
    },
    instructions: {
      fullNameHelp: 'أدخل اسمك القانوني الكامل كما يظهر في وثائقك الرسمية',
      dobHelp: 'أدخل تاريخ ميلادك بصيغة MM/DD/YYYY',
      uploadPhotoHelp: 'قم بتحميل صورة حديثة. يجب أن يكون الملف بصيغة JPG أو PNG أو GIF وأقل من 2 ميغابايت',
      passwordHelp: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل مع حرف كبير واحد، ورقم واحد، ورمز خاص واحد',
      documentHelp: 'الصيغ المقبولة: PDF، JPG، PNG (حد أقصى 5 ميغابايت)',
      requiredFields: 'الحقول المعلّمة بـ * مطلوبة',
      selectFromList: 'يرجى اختيار خيار من القائمة',
      nextTab: 'الانتقال إلى القسم التالي',
      previousTab: 'العودة إلى القسم السابق',
      saveInstructions: 'انقر على حفظ لتخزين معلوماتك',
      cancelInstructions: 'انقر على إلغاء للتخلص من التغييرات'
    },
    completionStatus: {
      notStarted: 'لم يبدأ',
      inProgress: 'قيد التقدم',
      complete: 'مكتمل',
      percentComplete: '{percent}% مكتمل',
      tabsCompleted: '{completed} من {total} أقسام مكتملة',
      tabComplete: 'تم إكمال القسم!'
    },
    gender: {
      male: 'ذكر',
      female: 'أنثى',
      other: 'آخر',
      preferNot: 'أفضل عدم القول'
    },
    maritalStatus: {
      single: 'أعزب',
      married: 'متزوج',
      divorced: 'مطلق',
      widowed: 'أرمل',
      other: 'آخر'
    },
    residencyStatuses: {
      citizen: 'مواطن',
      permanentResident: 'مقيم دائم',
      temporaryResident: 'مقيم مؤقت',
      other: 'آخر'
    },
    employmentStatuses: {
      employed: 'موظف',
      selfEmployed: 'عامل حر',
      unemployed: 'عاطل عن العمل',
      student: 'طالب',
      retired: 'متقاعد',
      homemaker: 'رب أسرة',
      other: 'آخر'
    },
    educationLevels: {
      primary: 'التعليم الابتدائي',
      secondary: 'التعليم الثانوي',
      highSchool: 'المدرسة الثانوية',
      vocational: 'التدريب المهني',
      associate: 'درجة مشارك',
      bachelor: 'درجة البكالوريوس',
      master: 'درجة الماجستير',
      doctoral: 'درجة الدكتوراه',
      professional: 'درجة مهنية',
      other: 'آخر'
    },
    proficiencyLevels: {
      native: 'أصلي',
      fluent: 'بطلاقة',
      advanced: 'متقدم',
      intermediate: 'متوسط',
      basic: 'أساسي'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'غير معروف'
    },
    languages: {
      english: 'الإنجليزية',
      french: 'الفرنسية',
      swahili: 'السواحلية',
      arabic: 'العربية',
      spanish: 'الإسبانية',
      portuguese: 'البرتغالية',
      chinese: 'الصينية',
      japanese: 'اليابانية',
      german: 'الألمانية',
      russian: 'الروسية',
      hindi: 'الهندية',
      urdu: 'الأردية',
      other: 'آخر'
    },
    yesNo: {
      yes: 'نعم',
      no: 'لا'
    },
    select: 'يرجى الاختيار',
    existingFile: 'ملف موجود',
    noMatchingCountries: 'لم يتم العثور على بلدان مطابقة',
    noMatchingDisciplines: "لم يتم العثور على تخصصات مطابقة",
    noMatchingDegrees: "لم يتم العثور على درجات مطابقة",
    educationOptions: [
      "المحاسبة", "هندسة الفضاء", "علوم الزراعة", "الأنثروبولوجيا", "العمارة",
      "تاريخ الفن", "الذكاء الاصطناعي", "الفلك", "فيزياء الفلك", "الكيمياء الحيوية",
      "هندسة الطب الحيوي", "التكنولوجيا الحيوية", "إدارة الأعمال", "هندسة الكيمياء",
      "الكيمياء", "هندسة المدني", "التواصل", "هندسة الحاسوب", "علوم الحاسوب",
      "إدارة الإنشاءات", "العدالة الجنائية", "الأمن السيبراني", "علوم البيانات", "طب الأسنان",
      "الاقتصاد", "التعليم", "هندسة الكهرباء", "التعليم الابتدائي", "الأدب الإنجليزي",
      "هندسة البيئة", "علوم البيئة", "تصميم الأزياء", "دراسات السينما",
      "المالية", "الفنون الجميلة", "علوم الغذاء", "العلوم الجنائية", "تصميم الألعاب",
      "الجغرافيا", "الجيولوجيا", "تصميم الجرافيك", "إدارة الصحة", "التاريخ",
      "إدارة الفنادق", "الموارد البشرية", "التصميم الصناعي", "الهندسة الصناعية", "نظم المعلومات",
      "تكنولوجيا المعلومات", "تصميم الداخلي", "الأعمال الدولية", "العلاقات الدولية",
      "الصحافة", "القانون", "علوم المكتبات", "اللغويات", "الإدارة", "التسويق",
      "علوم المواد", "الرياضيات", "الهندسة الميكانيكية", "دراسات الإعلام", "الطب",
      "الأرصاد الجوية", "علم الأحياء الدقيقة", "الموسيقى", "تكنولوجيا النانو", "التمريض", "التغذية",
      "العلاج المهني", "علوم المحيطات", "هندسة البترول", "الصيدلة", "الفلسفة",
      "التصوير الفوتوغرافي", "التربية البدنية", "العلاج الطبيعي", "الفيزياء", "العلوم السياسية",
      "علم النفس", "الإدارة العامة", "الصحة العامة", "العلاقات العامة", "الروبوتات",
      "التعليم الثانوي", "العمل الاجتماعي", "علم الاجتماع", "هندسة البرمجيات", "التعليم الخاص",
      "إدارة الرياضة", "الإحصاء", "هندسة النظم", "فنون المسرح", "السياحة",
      "التخطيط الحضري", "الطب البيطري", "تطوير الويب", "بيولوجيا الحياة البرية", "علم الحيوان"
    ],
    degreeOptions: [
      "درجة مشارك", "بكالوريوس في الآداب (BA)", "بكالوريوس في العلوم (BS)", "بكالوريوس في الهندسة (BEng)",
      "بكالوريوس في إدارة الأعمال (BBA)", "بكالوريوس في الفنون الجميلة (BFA)", "بكالوريوس في التربية (BEd)",
      "بكالوريوس في الطب (MBBS)", "بكالوريوس في القانون (LLB)", "ماجستير في الآداب (MA)", "ماجستير في العلوم (MS)",
      "ماجستير في إدارة الأعمال (MBA)", "ماجستير في الهندسة (MEng)", "ماجستير في الفنون الجميلة (MFA)",
      "ماجستير في التربية (MEd)", "ماجستير في القانون (LLM)", "ماجستير في الصحة العامة (MPH)",
      "دكتوراه في الفلسفة (PhD)", "دكتوراه في الطب (MD)", "دكتوراه في التربية (EdD)",
      "دكتوراه في إدارة الأعمال (DBA)", "دكتوراه في القانون (JD)", "دبلوم مهني",
      "دبلوم تقني", "شهادة مهنية", "شهادة خريج", "دبلوم خريج", "ما بعد الدكتوراه"
    ],
    aria: {
      tabList: 'أقسام نموذج الملف الشخصي',
      nextButton: 'الذهاب إلى القسم التالي',
      prevButton: 'الذهاب إلى القسم السابق',
      closeButton: 'إغلاق نموذج الملف الشخصي',
      saveButton: 'حفظ بيانات الملف الشخصي',
      requiredField: 'حقل مطلوب',
      dropdownSelect: 'اختر خيارًا'
    }
  },
  chatbot: {
    placeholder: 'اكتب استفسارك هنا...',
    sendButton: 'إرسال',
    fileReceived: 'تم استلام الملف بنجاح.',
    fileUploadError: 'خطأ في تحميل الملف.',
    processingError: 'خطأ في معالجة طلبك.',
    welcomeMessage: 'مرحبًا! كيف يمكنني مساعدتك في خدمات الحكومة الكينية اليوم؟',
    attachFile: 'إرفاق ملف',
    fileTooLarge: 'الملف كبير جدًا. الحجم الأقصى هو {maxSize}.',
    saveChat: 'حفظ المحادثة',
    chatSaved: 'تم حفظ المحادثة',
    chatTitle: 'عنوان المحادثة',
    chatTitlePlaceholder: 'أدخل عنوانًا لهذه المحادثة',
    selectFolder: 'اختر مجلدًا',
    newChat: 'محادثة جديدة',
    clearContext: 'مسح السياق وبدء محادثة جديدة',
    unsavedChanges: 'لديك تغييرات غير محفوظة. هل أنت متأكد من أنك تريد بدء محادثة جديدة؟',
    whatCanIHelp: "كيف يمكنني مساعدتك اليوم؟",
    justChat: "مجرد دردشة",
    queryContext: "سياق الاستعلام",
    contextAdded: 'تم إضافة السياق إلى استفسارك',
    contextRemoved: 'تم إزالة السياق من استفسارك',
    sessionUpdated: 'تم تحديث الجلسة',
    newChatStarted: 'بدأت محادثة جديدة',
    loadError: 'تعذر تحميل سجل المحادثة',
    responsePrefix: "تلقيت رسالتك",
    withContext: "مع السياق",
    conversationLoaded: "تم تحميل المحادثة بنجاح!",
    saveConfirmTitle: "حفظ المحادثة الحالية",
    saveConfirmMessage: "حفظ المحادثة الحالية؟",
    loadConfirmTitle: "تحميل المحادثة الحالية",
    loadConfirmMessage: "لديك تغييرات غير محفوظة. هل تريد التخلص منها وتحميل المحادثة المحددة، أو حفظ المحادثة الحالية أولاً؟",
    loadAndDiscard: "تحميل والتخلص",
    saveAndLoad: "حفظ وتحميل",
    saveAndStartNew: "حفظ وبدء جديد",
    discardAndStartNew: "التخلص وبدء جديد",
    newChatTitle: "بدء محادثة جديدة",
    exportChat: 'تصدير المحادثة',
    exportFilename: 'اسم الملف',
    exportFilenamePlaceholder: 'أدخل اسم الملف',
    exportButton: 'تصدير',
    exportSuccess: 'تم تصدير المحادثة بنجاح',
    exportError: 'فشل تصدير المحادثة. يرجى المحاولة مرة أخرى.'
  },
  quickhelp: {
    // Labels (Short for UI)
    applyForID: "طلب الهوية",
    payTaxes: "دفع الضرائب",
    startBusiness: "بدء عمل تجاري",
    findHealthcare: "الرعاية الصحية",
    educationServices: "التعليم",
    transportLicenses: "النقل",
    housingPrograms: "الإسكان",
    findJobs: "إيجاد وظائف",
    justChat: "دردشة فقط",

    // User Prompts (Visible Text - First Person - what user sees in chat)
    justChatUserPrompt: "أود الدردشة حول الخدمات الحكومية",
    applyForIDUserPrompt: "أحتاج إلى معلومات حول كيفية تقديم طلب للحصول على بطاقة الهوية الوطنية",
    payTaxesUserPrompt: "ما هو العملية لدفع الضرائب عبر الإنترنت؟",
    startBusinessUserPrompt: "دلني على الخطوات لتسجيل عمل جديد",
    findHealthcareUserPrompt: "أين يمكنني العثور على معلومات حول خدمات الرعاية الصحية العامة؟",
    educationServicesUserPrompt: "ما هي خدمات التعليم المتاحة لأطفالي؟",
    transportLicensesUserPrompt: "كيف أجدد رخصة القيادة الخاصة بي؟",
    housingProgramsUserPrompt: "أخبرني عن برامج الإسكان الميسورة التكلفة في كينيا",
    findJobsUserPrompt: "ما هي فرص العمل الحكومية المتاحة حاليًا؟",

    // System Prompts (Hidden from User - detailed prompts sent to LLM)
    applyForIDPrompt: "تصرف كخبير مفيد في التسجيل المدني الكيني. اشرح خطوات الحصول على الهوية الوطنية (Maisha Namba) أو استبدال هوية مفقودة. هام: قدم قائمة واضحة بالمستندات المطلوبة (مثل شهادة الميلاد، ونسخ من هويات الوالدين) وانصح المستخدم بزيارة أقرب مركز Huduma Centre أو مكتب مسجل الأشخاص. قاعدة: أشر دائمًا إلى التطبيق باسم 'Genie AI'.",

    payTaxesPrompt: "تصرف كدليل لـ KRA (هيئة الإيرادات الكينية). اشرح عملية تقديم الإقرارات، أو التقدم بطلب للحصول على KRA PIN، أو إعادة تعيين كلمة المرور على بوابة iTax. هام: ذكّر المستخدم بموعد 30 يونيو النهائي للإقرارات السنوية ووجهه حول كيفية تقديم إقرارات صفرية (Nil returns) إذا لم يكن لديه دخل. قاعدة: أشر دائمًا إلى التطبيق باسم 'Genie AI'.",

    startBusinessPrompt: "تصرف كمستشار أعمال لخدمات eCitizen. وجه المستخدم خلال حجز الاسم التجاري وتسجيل الشركة في كينيا. هام: اشرح التكاليف الحالية للبحث عن الاسم والتسجيل، ووجه المستخدم إلى بوابة eCitizen الرسمية لإكمال الطلب. قاعدة: أشر دائمًا إلى التطبيق باسم 'Genie AI'.",

    findHealthcarePrompt: "تصرف كموجه للخدمات الصحية. قدم معلومات حول الانتقال من NHIF إلى SHIF (صندوق التأمين الصحي الاجتماعي) وكيفية التسجيل. هام: شارك رموز USSD الرسمية (مثل *263#) أو روابط الموقع للتسجيل واشرح فوائد التغطية الصحية العامة. قاعدة: أشر دائمًا إلى التطبيق باسم 'Genie AI'.",

    educationServicesPrompt: "تصرف كمستشار تعليمي. ناقش منهج CBC، أو تسجيل NEMIS، أو القبول الجامعي عبر KUCCPS. هام: اشرح كيف يمكن للوالدين التحقق من نتائج الامتحانات الوطنية عبر الرسائل القصيرة أو بوابة KNEC عند إصدارها. قاعدة: أشر دائمًا إلى التطبيق باسم 'Genie AI'.",

    transportLicensesPrompt: "تصرف كدليل لخدمات NTSA. اشرح عملية تجديد رخصة القيادة، أو فحص المركبات، أو إدارة حساب TIMS. هام: وجه المستخدم حول كيفية تسجيل الدخول إلى بوابة eCitizen NTSA لتقديم طلب للحصول على Smart DL أو حجز فحص للمركبة. قاعدة: أشر دائمًا إلى التطبيق باسم 'Genie AI'.",

    housingProgramsPrompt: "تصرف كمستشار لبرنامج الإسكان. اشرح التسجيل في برنامج الإسكان الميسر (Boma Yangu) وعملية المساهمة الطوعية. هام: وجه المستخدم إلى بوابة Boma Yangu لعرض المشاريع وشرح معايير الأهلية للتخصيص. قاعدة: أشر دائمًا إلى التطبيق باسم 'Genie AI'.",

    findJobsPrompt: "تصرف كمدرب مهني للخدمة العامة. وجه المستخدم لإنشاء ملف تعريف والتقدم للوظائف الشاغرة عبر بوابة لجنة الخدمة العامة (PSC). هام: انصح المستخدم بتجهيز شهاداته الأكاديمية والتحقق بانتظام من موقع PSC أو الصحف المحلية لإعلانات MyGov. قاعدة: أشر دائمًا إلى التطبيق باسم 'Genie AI'.",

    justChatPrompt: "تصرف كرفيق محلي ودود. كن مهذبًا ومفيدًا وملمًا بالثقافة الكينية والحياة اليومية. هام: ذكّر المستخدم بأنه بينما يمكنك الدردشة حول أي شيء، فإن قوتك الرئيسية تكمن في مساعدتهم على التنقل في الخدمات الحكومية الكينية مثل **الهويات**، و**الضرائب**، و**تسجيل الأعمال**. قاعدة: أشر دائمًا إلى التطبيق باسم 'Genie AI'."
  },
  common: {
    cancel: 'إلغاء',
    create: 'إنشاء',
    save: 'حفظ',
    move: 'نقل',
    delete: 'حذف',
    // --- NEW KEYS ADDED ---
    ok: 'موافق',
    ingest: 'استيعاب',
    retract: 'سحب',
    loading: 'جاري التحميل...',
    refresh: 'تحديث'
  },
  feedback: {
    title: 'التعليق',
    button: 'التعليق',
    positive: 'تعليق إيجابي',
    negative: 'تعليق سلبي',
    promptText: 'هل كان هذا الرد مفيدًا؟',
    placeholder: 'تعليقات إضافية...',
    submit: 'إرسال التعليق',
    close: 'إلغاء',
    thankYouMessage: 'شكرًا على تعليقك!',
    submitting: 'جاري الإرسال...',
    error: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    success: 'شكرًا على تعليقك!'
  },
  responseRating: {
    title: 'ساعدنا على التحسين',
    note: 'سيتم استخدام تعليقك لضبط الروبوت الدردشة بشكل أفضل وتحسين الردود مع مرور الوقت.',
    chatbotResponse: 'رد الروبوت الدردشة:',
    ratingLabels: {
      1: 'غير مفيد',
      2: 'مفيد قليلاً',
      3: 'مفيد إلى حد ما',
      4: 'مفيد جدًا',
      5: 'يغير الحياة'
    },
    additionalComments: 'تعليقات إضافية...',
    submit: 'إرسال',
    cancel: 'إلغاء'
  },
  upload: {
    alt: 'تحميل'
  },
  details: {
    loading: 'جاري تحميل تفاصيل الملف...',
    title: 'تفاصيل الملف',
    close: 'إغلاق',
    fileName: 'اسم الملف',
    author: 'المؤلف',
    labels: 'العلامات',
    selectAll: 'تحديد الكل',
    loadingLabels: 'جاري تحميل العلامات...',
    status: 'الحالة',
    fileId: 'معرف الملف',
    fileType: 'نوع الملف',
    viewFile: 'عرض الملف',
    visitLink: 'زيارة رابط خارجي',
    openFile: 'فتح الملف في علامة تبويب جديدة',
    fileSize: 'حجم الملف',
    uploadDate: 'تاريخ الرفع',
    hash: 'تجزئة SHA256',
    // --- NEW: TABS ---
    tabs: {
      details: "التفاصيل",
      ingestionLog: "سجل الاستيعاب"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "إجراءات الإنهاء:",
      killDocument: "إنهاء هذا المستند",
      killProcess: "إنهاء عملية الاستيعاب",
      timestamp: "الطابع الزمني",
      level: "المستوى",
      stage: "المرحلة",
      message: "الرسالة",
      loadingLogs: "جاري تحميل السجلات...",
      noLogs: "لم يتم العثور على سجلات."
    },
    buttons: {
      saveMetadata: 'حفظ البيانات الوصفية',
      retract: 'سحب',
      ingest: 'استيعاب'
    },
    notifications: {
      loadError: 'فشل تحميل تفاصيل الملف.',
      validationError: 'اسم الملف والمؤلف مطلوبان.',
      saveSuccess: 'تم تحديث البيانات الوصفية بنجاح.',
      saveError: 'فشل حفظ البيانات الوصفية.',
      tokenError: 'لم يتم العثور على رمز المصادقة في بيانات المستخدم.',
      viewError: 'لم يمكن تحميل الملف للعرض.',
      ingestSuccess: 'تم وضع الملف في قائمة الانتظار للاستيعاب بنجاح.',
      ingestError: 'فشل بدء عملية الاستيعاب.',
      retractSuccess: 'تم سحب الملف بنجاح.',
      retractError: 'فشل سحب الملف.',
      deleteSuccess: 'تم حذف الملف بنجاح.',
      deleteError: 'فشل حذف الملف.',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "يرجى اختيار علامة واحدة على الأقل قبل الاستيعاب.",
      ingestSaving: "جاري حفظ البيانات الوصفية قبل الاستيعاب...",
      ingestSaveFailed: "فشل حفظ البيانات الوصفية. تم إلغاء الاستيعاب.",
      logError: "فشل جلب سجلات الاستيعاب.",
      killDocSent: "تم إرسال طلب إنهاء لهذا المستند.",
      killProcSent: "تم إرسال طلب إنهاء لعملية الاستيعاب."
    },
    confirm: {
      ingest: 'هل أنت متأكد أنك تريد استيعاب هذا الملف؟ سيبدأ هذا عملية معالجة البيانات.',
      retract: 'هل أنت متأكد أنك تريد سحب هذا الملف؟',
      delete: 'هل أنت متأكد أنك تريد حذف هذا الملف نهائيًا؟ لا يمكن التراجع عن هذا الإجراء.',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "تأكيد الاستيعاب",
      retractTitle: "تأكيد السحب",
      deleteTitle: "تأكيد الحذف",
      killDocTitle: "إنهاء استيعاب المستند",
      killDoc: "هل أنت متأكد من أنك تريد إنهاء مهمة الاستيعاب لهذا المستند؟ ستحاول العملية التراجع بأمان.",
      killProcTitle: "إنهاء عملية الاستيعاب بأكملها",
      killProc: "تحذير: سيؤدي هذا إلى إنهاء خدمة الاستيعاب الخلفية بأكملها، مما يؤثر على جميع الملفات قيد المعالجة حاليًا. هل أنت متأكد تمامًا؟"
    }
  },
  uploadDialog: {
    title: 'تحميل الملفات',
    dropzone: 'اسحب وأفلت الملفات هنا، أو انقر للاختيار',
    allowedTypesLabel: 'الأنواع المسموح بها:',
    buttonUpload: 'تحميل {count} ملف (ملفات)',
    remove: 'إزالة',
    uploading: 'جاري الرفع...',
    notifications: {
      dropError: 'يمكن إفلات الملفات فقط. يرجى التحقق من أنك تسحب ملفًا صالحًا من جهاز الكمبيوتر الخاص بك.',
      typeNotAllowed: 'نوع الملف "{extension}" غير مسموح به.',
      shortcutUnsupported: 'ملفات الاختصار (.url) غير مدعومة. يرجى سحب الملف الفعلي.',
      duplicate: 'تمت إضافة الملف "{fileName}" بالفعل.',
      uploadSuccess: 'تم تحميل {fileName} بنجاح',
      uploadFailed: 'فشل تحميل {fileName}.'
    }
  }
}